import { Typography } from 'antd';
import React, { useEffect } from 'react';
import { commonHelpers } from 'utilities/helpers';

interface props {
    label?: string;
    value?: any;
    labelClassName: string;
    suffix?: string;
    formatNumber?: boolean;
    suffixLinkText?: string;
    onClickLink?: (value: any) => void;
    className?: string;
    type?: string;
    options?: any[];
    defaultValue?: any;
    dateFormat?: string;
}

export const ItemView = ({
    suffix,
    label,
    labelClassName = '',
    value,
    options,
    type,
    defaultValue = '-',
    dateFormat,
}: props) => {
    const [displayValue, setDisplayValue] = React.useState<any>('');

    useEffect(() => {
        if (value) {
            let displayValue = value;
            if (options) {
                const option = options.find((item) => item.value == value);
                if (option) {
                    displayValue = option.label;
                }
            }
            if (type === 'number') {
                displayValue = commonHelpers.formatNumberMoney(value);
            }
            if (dateFormat) {
                displayValue = commonHelpers.formatDate(value, dateFormat);
            }
            setDisplayValue(displayValue + `${suffix ?? ''}`);
        } else if (defaultValue) {
            setDisplayValue(defaultValue);
        }
    }, [value, options]);

    return (
        <>
            <div className={labelClassName}>{label}</div>
            <Typography.Text className="content-step-form">{displayValue}</Typography.Text>
        </>
    );
};
